<template>
  <v-app>
    <v-overlay :value="processing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div>
      <section :class="$style.form">
        <div :class="$style['logo']">
          <Logo width="100%" />
        </div>
        <h2 class="text-center my-6">
          {{title}}
        </h2>
        <form>
          <CRow>
            <CCol sm="12">
              <CInput
                      v-model="loginId"
                      label="ID"
                      placeholder="ID"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12">
              <CInput
                      v-model="password"
                      type="password"
                      label="パスワード"
                      placeholder="パスワード"
              />
            </CCol>
          </CRow>
        </form>
        <div v-if="isError" :class="$style['error']">
          <span>ID/パスワードの組合せが正しくありません。</span>
        </div>
        <v-btn block color="#ff9900" dark @click="onLogin">ログイン</v-btn>
        <div :class="$style['desc']">
          <span>※ 誤ったパスワードの入力を一定時間内に繰り返すとアカウントがロックされます。入力を3回誤った場合はしばらく時間を置いてから再度入力してください。</span>
        </div>
        <div :class="$style['password']">
          <span>パスワードをお忘れの方は</span><a @click="onChangePassword">こちら</a>
        </div>
      </section>
    </div>
    <PasswordReissueDialog resourceName="login" />
  </v-app>
</template>

<script>
import Logo from '@/components/logo';
import {auth} from '../plugins/firebase';
import utility from "@/utility";
import PasswordReissueDialog from "@/components/dialogs/password-reissue-dialog";

export default {
  components: {
    Logo,
    PasswordReissueDialog
  },
  data() {
    return {
      loginId: "",
      password: ""
    };
  },
  computed: {
    isError() {
      return this.$store.getters["auth/isError"];
    },
    processing() {
      return this.$store.getters[`auth/processing`];
    },
    title() {
      return '管理画面' + (process.env.NODE_ENV !== 'production' ? ' (検証環境)' : '')
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    },
    permissionAll() {
      return this.$store.getters[`auth/permissionAll`];
    },
    permissionMakerView() {
      return this.$store.getters[`auth/permissionMakerView`];
    },
    permissionUserView() {
      return this.$store.getters[`auth/permissionUserView`];
    },
    permissionArticleView() {
      return this.$store.getters[`auth/permissionArticleView`];
    }
  },
  methods: {
    onLogin() {
      auth.signInWithEmailAndPassword(this.loginId, this.password)
        .then((user) => {
          if (user != null) {
              this.$store
                .dispatch("auth/login", {
                  loginId: this.loginId
                })
                .then(() => {
                  const path = this.isProvider ? (
                      this.permissionAll ? "users" :
                        (this.permissionUserView ? "users" :
                          (this.permissionMakerView ? "makers" :
                            (this.permissionArticleView ? "topics" : /*"change_password"*/ "dashboard")))
                    ) :
                    "recipes";
                  this.$router.push(this.$route.query.prev || {name: path});
                })
                .catch(() => {
                });
          }else{
            utility
              .$alert("ユーザ情報の取得に失敗しました。", "エラー", {
                confirmButtonText: "OK",
                type: "error",
                center: true
              })
              .then(() => {});
          }
        })
        .catch((e) => {
          switch (e.code){
            case 'auth/wrong-password':
              utility
                .$alert("ID/パスワードの組み合わせが正しくありません。", "エラー", {
                  confirmButtonText: "OK",
                  type: "error",
                  center: true
                })
                .then(() => {});
              break;
            case 'auth/user-not-found':
              utility
                .$alert("ID/パスワードの組み合わせが正しくありません。", "エラー", {
                  confirmButtonText: "OK",
                  type: "error",
                  center: true
                })
                .then(() => {});
              break;
            default:
              utility
                .$alert("ログイン処理に失敗しました。", "エラー", {
                  confirmButtonText: "OK",
                  type: "error",
                  center: true
                })
                .then(() => {});
              break;
          }
        });
    },
    onChangePassword() {
      this.$store.commit("passwordReissue/open", {id: null});
    },
  },
  created() {
    /*
    window.addEventListener("popstate", function (e) {
      window.history.go(1);
      return;
    });
    window.history.pushState(null, null, null);
    */
  }
}
</script>

<style module>
.form {
  background-color: #ffffff;
  width: 350px;
  min-width: 300px;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 15px 30px;
}

.error {
  color: #ff1100;
  text-align: center;
}

.desc {
  width: 600px;
  transform: translate(-25%, 0%);
  padding: 15px 30px;
}

.password {
  text-align: center;
}

.logo {
  width: 100%;
  position: relative;
  left: -24px;
  padding: 0;
  margin-bottom: 60px;
}
</style>
